import { RouteNamesEnum } from '@/enums/RouteNamesEnum';

const AuthRoutes = [
    {
        name: RouteNamesEnum.Login,
        path: '/',
        component: () => import('@/views/general/LoginView.vue'),
        meta: {
            title: 'LoginView.title',
            auth: {
                required: false,
            },
            showInMenu: false,
        },
    },
    {
        name: RouteNamesEnum.Register,
        path: '/register',
        component: () => import('@/views/general/RegisterView.vue'),
        meta: {
            title: 'RegisterView.title',
            auth: {
                required: false,
            },
            showInMenu: false,
        },
    },
    {
        path: '/reset-password',
        name: RouteNamesEnum.ResetPassword,
        component: () => import('../views/general/ResetPasswordView.vue'),
        meta: {
            title: 'ResetPassword.title',
            auth: {
                required: false,
            },
            showInMenu: false,
        },
    },
];

export default AuthRoutes;
